import { render, staticRenderFns } from "./generalinquiryList.vue?vue&type=template&id=62c79958"
import script from "./generalinquiryList.vue?vue&type=script&lang=js"
export * from "./generalinquiryList.vue?vue&type=script&lang=js"
import style0 from "./generalinquiryList.vue?vue&type=style&index=0&id=62c79958&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports